import React from "react";

export default class SubscriptionSection extends React.Component {
    render() {
        const props = this.props;
        const btn = props.regAction ? (
            <a className='pubhub-subscription-reg-action btn btn-lg-wide btn-primary' href={props.regActionUrl} target={props.regActionTarget} rel={props.regActionTarget === '_blank' ? 'noopener noreferrer' : undefined}>
                {props.regAction}
            </a>
        ) : null;

        return (
            <div className='pubhub-subscription'>
                <div className='container'>
                    <div className='pubhub-subscription-title'>{props.title}</div>
                    <div className='pubhub-subscription-subtitle'>{props.subTitle}</div>
                    {btn}
                    {this.renderBenefits(props.benefits)}
                </div>
            </div>
        );
    }

    renderBenefits(benefits) {
        return (
            <div className='pubhub-subscription-benefits'>
                <div className='pubhub-subscription-benefits-title'>{benefits.title}</div>
                <ul>
                    {
                        benefits.list.map((item, idx) => {
                            return (
                                <li key={idx}>
                                    {item}
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        );
    }
}
